module.exports = __webpack_public_path__ + "img/fish.25b71781.gif";